import type { SlackChannelBinding } from './types';

/** Slack deep links — profile `/team/<U…>`, channel `/archives/<C…>`. Falls back when domain unknown. */
export function slackUserProfileUrl(workspaceBaseUrl: string | null, teamId: string, userId: string): string {
  return workspaceBaseUrl
    ? `${workspaceBaseUrl}/team/${userId}`
    : `slack://user?team=${encodeURIComponent(teamId)}&id=${encodeURIComponent(userId)}`;
}

export function slackChannelUrl(workspaceBaseUrl: string | null, teamId: string, channelId: string): string {
  return workspaceBaseUrl
    ? `${workspaceBaseUrl}/archives/${channelId}`
    : `https://app.slack.com/client/${teamId}/${channelId}`;
}

/** Human label for a bound conversation: `#channel`, else the conversation kind. */
export function channelLabel(binding: SlackChannelBinding): string {
  if (binding.channelName) return `#${binding.channelName}`;
  if (binding.channelIsIm) return 'Direct message';
  if (binding.channelIsMpim) return 'Group DM';
  if (binding.channelIsPrivate) return 'Private channel';
  return binding.channelId;
}

/** Up to two leading initials from the workspace name, e.g. "Acme Corp" → "AC". */
export function workspaceInitials(name: string | null | undefined): string {
  const initials = (name ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('');
  return initials || 'S';
}
